import { render, staticRenderFns } from "./OrganizationCreateView.vue?vue&type=template&id=5de2c754&"
import script from "./OrganizationCreateView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports